import { combineReducers } from 'redux';
import { RecoveredCart } from '@pegasus/cart';

import { fetchRecoveredCart } from 'src/client/api/services/cart';
import { defineFetchForNamespace } from 'src/client/components/shared/redux/fetch';

export const NAME = 'fetch';
export const NAMESPACE = 'recoveredCart';

const {
    reducer,
    getIsInitial,
    getIsLoading,
    getData,
    resetData,
    fetchData,
} = defineFetchForNamespace<RecoveredCart, void, typeof NAMESPACE, typeof NAME>(
    NAMESPACE,
    NAME,
    () => fetchRecoveredCart(),
);

const getRecoveredCartReducer = () => ({
    [NAMESPACE]: combineReducers({
        [NAME]: reducer,
    }),
});

export {
    getRecoveredCartReducer,
    getIsInitial,
    getIsLoading,
    getData as getRecoveredCart,
    fetchData as fetchRecoveredCart,
    resetData as resetCart,
};
